import { type MouseEventHandler, forwardRef } from 'react';

import classNames from 'classnames';

import styles from './SubmitButton.module.css';

import { ButtonBase } from '../../ButtonBase';

export interface SubmitButtonProps {
  /** Visible button text. Used as the accessible name. */
  label: string;
  /** Click handler. Not invoked while the button is disabled. */
  onClick: MouseEventHandler<HTMLButtonElement>;
  /** Render the button as disabled. */
  disabled?: boolean;
  /**
   * The native button type.
   *
   * @defaultValue 'submit'
   */
  type?: 'submit' | 'button';
  /** Forwarded to the underlying button element. */
  className?: string;
}

/**
 * Inline submit affordance rendered inside the foundation {@link Input}'s
 * outline. Mirrors the structure of {@link RevealButton}.
 *
 * @internal
 */
export const SubmitButton = forwardRef<HTMLButtonElement, SubmitButtonProps>(
  function SubmitButton(props, ref) {
    const {
      label,
      onClick,
      disabled = false,
      type = 'submit',
      className,
    } = props;

    return (
      <ButtonBase
        ref={ref}
        type={type}
        onClick={onClick}
        disabled={disabled}
        className={classNames(styles.button, className, {
          [styles.disabled]: disabled,
        })}
      >
        {label}
      </ButtonBase>
    );
  }
);
